import { computed, defineAsyncComponent, ref, markRaw } from 'vue'

export const useGeneratePage = () => {
  const options = {
    afterHowManyItemsAddAd: 2,
    showAdSlots: true,
	maxAds: 4
  }

  const pageSettings = computed(() => window?.__pageSettings)

  const componentsByType = ref({
    'ELECTIONS-PARLIAMENTARY': markRaw(
      defineAsyncComponent(() => import('@/components/elections/ModuleElections.vue'))
    ),
    'ELECTIONS-LOCAL': markRaw(
      defineAsyncComponent(() => import('@/components/elections/local/ModuleElectionsLocal.vue'))
    ),
    'ELECTIONS-LOCAL-CITY-MAYORS': markRaw(
      defineAsyncComponent(() => import('@/components/elections/local/ModuleElectionsLocalCityMayors.vue'))
    ),
    DRIVER: markRaw(defineAsyncComponent(() => import('@/components/modules/ModuleDriver.vue'))),
    'DRIVER-MOURNING': markRaw(
      defineAsyncComponent(() => import('@/components/modules/ModuleDriver.vue'))
    ),
    'DRIVER-URGENT': markRaw(
      defineAsyncComponent(() => import('@/components/modules/ModuleDriver.vue'))
    ),
    BANNER: markRaw(defineAsyncComponent(() => import('@/components/modules/ModuleBar.vue'))),
    'PLAYER-SECTION': markRaw(defineAsyncComponent(() => import('@/components/modules/ModuleFloat.vue'))),
    'BANNER-MOURNING': markRaw(
      defineAsyncComponent(() => import('@/components/modules/ModuleBlackBar.vue'))
    ),
    GALLERY: markRaw(defineAsyncComponent(() => import('@/components/modules/ModulePhoto.vue'))),
    VIDEO: markRaw(defineAsyncComponent(() => import('@/components/modules/ModuleVideo.vue'))),
    BIGBOX: markRaw(defineAsyncComponent(() => import('@/components/modules/ModuleLargeBox.vue'))),
    '1+4': markRaw(
      defineAsyncComponent(() => import('@/components/modules/ModuleOneFourBoxes.vue'))
    ),
    '1+4+3': markRaw(
      defineAsyncComponent(() => import('@/components/modules/ModuleOneFourThreeBoxes.vue'))
    ),
    '1+2+2': markRaw(
      defineAsyncComponent(() => import('@/components/modules/ModuleOneTwoTwoBoxes.vue'))
    ),

    'MOST-POPULAR': markRaw(
      defineAsyncComponent(() => import('@/components/modules/ModulePopular.vue'))
    ),
    '2-BOXES': markRaw(
      defineAsyncComponent(() => import('@/components/modules/ModuleTwoBoxes.vue'))
    ),
    '3-BOXES': markRaw(
      defineAsyncComponent(() => import('@/components/modules/ModuleThreeBoxes.vue'))
    ),
    REGIONS: markRaw(defineAsyncComponent(() => import('@/components/regions/ModuleRegions.vue'))),
    MAGAZINE: markRaw(defineAsyncComponent(() => import('@/components/modules/ModuleWeekly.vue'))),
    '2+LATEST': markRaw(
      defineAsyncComponent(() => import('@/components/modules/ModuleTwoLatest.vue'))
    ),
    // Live
    LIVE: markRaw(
      defineAsyncComponent(() => import('@/components/modules/live/ModuleLiveVideo.vue'))
    ),
    'POSTER-PROMO-LIVE': markRaw(
      defineAsyncComponent(() => import('@/components/modules/live/ModulePosterPromoLive.vue'))
    ),
    FAQ: markRaw(defineAsyncComponent(() => import('@/components/modules/live/ModuleLive.vue'))),
    '4-BOXES': markRaw(
      defineAsyncComponent(() => import('@/components/modules/live/ModuleFourBoxesLive.vue'))
    ),
    POSTER: markRaw(
      defineAsyncComponent(() => import('@/components/modules/live/ModulePosterLive.vue'))
    ),
    REPORT: markRaw(defineAsyncComponent(() => import('@/components/modules/ModuleReport.vue'))),
    'DRIVER-EXTRA': markRaw(
      defineAsyncComponent(() => import('@/components/modules/ModuleDriverExtra.vue'))
    ),
    APOLOGIES: markRaw(
      defineAsyncComponent(() => import('@/components/modules/ModuleApology.vue'))
    ),
    // ProgramDirectoryPage blocks
    NEWEST_ONE: markRaw(
      defineAsyncComponent(() => import('@/components/program/news/ProgramNewsVideo.vue'))
    ),
    BLOCK: markRaw(defineAsyncComponent(() => import('@/components/modules/ModuleFourBoxesBlock.vue'))),
    TOP5: markRaw(defineAsyncComponent(() => import('@/components/modules/ModuleTopFive.vue'))),
    DIRECTORY_GRID: markRaw(
      defineAsyncComponent(() => import('@/components/modules/ModuleFourBoxes.vue'))
    ),
    BLOCK_WEBSITE: markRaw(
      defineAsyncComponent(() => import('@/components/modules/ModuleSliderPerson.vue'))
    ),
    DRIVER_WEBSITE: markRaw(
      defineAsyncComponent(() => import('@/components/modules/ModuleBigSlider.vue'))
    ),
    FORM: markRaw(defineAsyncComponent(() => import('@/components/elements/ContactForm.vue')))
  })

  const loadComponent = (type) => componentsByType.value?.[type] ?? false

//   const addAd = (index, startIndex) =>
//     options.showAdSlots && index >= 4 && index % options.afterHowManyItemsAddAd === 0 && index !== 0
	const addAd = (index, startIndex) => {

		if (!options.showAdSlots) return false
		if (index < startIndex) return false
	
		const maxIndex = startIndex + (options.maxAds - 1) * options.afterHowManyItemsAddAd
	
		if (index > maxIndex) return false
		console.log(index)
		return (index - startIndex) % options.afterHowManyItemsAddAd === 0
	}

  return { pageSettings, loadComponent, addAd }
}
